import * as React from 'react';
import { PresentationType } from 'app/components/favourite-layout';
import {
  tableOptions, tileOptions, tileAttributeMappings, tableAttributeMappings,
  heatmapType, heatmapOptions, heatmapAttributeMappings
} from './constants';
import { LayoutAttributesSelector } from './attributes-selector';
import { AttributesPickerTranslation } from './types';

export interface AttributesPickerProps {
  presentationType: number;
  layoutAttributes: { [key: string]: string | boolean };
  onAttributeChange: (value: { [key: string]: string | boolean }) => void;
  translations: AttributesPickerTranslation;
}

export const AttributesPicker = (props: AttributesPickerProps) => {

  if (props.presentationType === PresentationType.Table) {
    return <LayoutAttributesSelector
      options={tableOptions}
      attributesMapping={tableAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Tile) {
    return <LayoutAttributesSelector
      options={tileOptions}
      attributesMapping={tileAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  if (props.presentationType === PresentationType.Highcharts
    && props.layoutAttributes[heatmapType]) {
    return <LayoutAttributesSelector
      options={heatmapOptions}
      attributesMapping={heatmapAttributeMappings}
      layoutAttributes={props.layoutAttributes}
      onChange={props.onAttributeChange}
      translations={props.translations}
    />;
  }

  return null;
};
